const slideModule = {
  // other module props
  id: 1,
  component: "CRImageSlide",
  config: {
    header: {
      isTextInCaps: false,
      text: "Consequat cillum quis nulla",
      textColor: {
        label: "Color 1",
        value: "#1D1D1F",
      },
    },
    text: {
      text: "Incididunt minim duis quis do mollit nulla pariatur non. Consectetur et eiusmod excepteur voluptate mollit velit ad duis excepteur est minim aliqua ad. Sit dolor reprehenderit do minim.",
      textColor: {
        label: "Color 2",
        value: "#566A7A",
      },
    },
    media: {
      url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
      mediaType: "image",
    },
    showMedia: false,
    ctaButton: {
      text: "Learn more",
      fillStyle: {
        label: "Fill",
        value: "fill",
      },
      corners: {
        label: "Round",
        value: "round",
      },
      link: {
        type: {
          label: "External Link",
          value: "external",
        },
        url: "https://www.example.com",
        scrollTarget: {
          label: "FAQ",
          value: "7c205826-8720-3b35-884d-b4aa2a32b7f9",
        },
      },
      backgroundColor: {
        label: "Black",
        value: "#000",
      },
      textColor: {
        label: "Green",
        value: "#2bcd41",
      },
    },
  },
};

export default slideModule;
